import { render } from "./ContractsList.vue?vue&type=template&id=284959d0"
import script from "./ContractsList.vue?vue&type=script&lang=js"
export * from "./ContractsList.vue?vue&type=script&lang=js"
script.render = render

export default script